export const techStack = [
  {
    category: "Languages",
    items: [
      { name: "Python", icon: "python", color: "#3776AB" },
      { name: "JavaScript", icon: "javascript", color: "#F7DF1E" },
      { name: "TypeScript", icon: "typescript", color: "#3178C6" },
      { name: "HTML5", icon: "html5", color: "#E34F26" },
      { name: "CSS3", icon: "css3", color: "#1572B6" },
      { name: "SQL", icon: "postgresql", color: "#336791" },
    ],
  },
  {
    category: "Frameworks & Libraries",
    items: [
      { name: "React", icon: "react", color: "#61DAFB" },
      { name: "Django", icon: "django", color: "#092E20" },
      { name: "Flask", icon: "flask", color: "#000000" },
      { name: "Tailwind CSS", icon: "tailwindcss", color: "#06B6D4" },
      // { name: "Framer Motion", icon: "framer", color: "#FF0055" },
      { name: "NestJS", icon: "nestjs", color: "#000000" },
    ],
  },
  {
    category: "AI & Machine Learning",
    items: [
      { name: "TensorFlow", icon: "tensorflow", color: "#FF6F00" },
      { name: "PyTorch", icon: "pytorch", color: "#EE4C2C" },
      { name: "OpenCV", icon: "opencv", color: "#5C3EE8" },
      { name: "scikit-learn", icon: "scikitlearn", color: "#F79320" },
      { name: "Pandas", icon: "pandas", color: "#150458" },
      { name: "NumPy", icon: "numpy", color: "#013243" },
    ],
  },
  {
    category: "Tools & Platforms",
    items: [
      { name: "Git", icon: "git", color: "#F05032" },
      { name: "GitHub", icon: "github", color: "#181717" },
      { name: "Docker", icon: "docker", color: "#2496ED" },
      { name: "AWS", icon: "amazonwebservices", color: "#FF9900" },
      { name: "NVIDIA Jetson", icon: null, color: "#76B900" },
      { name: "Linux", icon: "linux", color: "#FCC624" },
    ],
  },
];